module.exports = __webpack_public_path__ + "img/0070.53e5d894.jpg";